<template>
    <div class="custom-form-select">
        <p class="custom-select-value">
            {{computed_label}}
        </p>
        <div class="custom-form-dropdown" ref="dropdown">
            <ul>
                <li v-for="option in options" :key="option.key" @click="change(option)">{{ option.label }}</li>
            </ul>
        </div>
    </div>
</template>

<script>
export default {
    name:'Selector',
    props:['label', 'options', 'value'],
    data(){
        return {
            selected: null
        }
    },
    computed:{
        computed_label: function() {
            if (this.selected) {
                return this.selected.label
            }
            return this.label
        }
    },
    methods:{
        change(option) {
            let dropdown = this.$refs.dropdown
            dropdown.classList.add('hide')
            window.setTimeout(() => {
                dropdown.classList.remove('hide')

            }, 200)
            this.selected = option
            this.$emit('input', option.key)
        }
    }
}
</script>

<style>
    .hide{
        display:none !important
    }
</style>